import {
  Autocomplete,
  Box,
  Button,
  Chip,
  FormControl,
  FormLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { IResourceComponentsProps, useTranslation } from "@refinedev/core";
import { Edit } from "@refinedev/mui";
import { useForm } from "@refinedev/react-hook-form";
import React from "react";
import { Controller, FormProvider, useFieldArray } from "react-hook-form";
import { useQuery } from "react-query";
import { getClients } from "services/client";
import { getContainers } from "services/container";
import { ReiceptsForm } from "./components/Form";

export const ReceiptEdit: React.FC<IResourceComponentsProps> = () => {
  const { translate } = useTranslation();
  const {
    refineCore: { queryResult },
  } = useForm();

  // const creditsData = queryResult?.data?.data;

  const form = useForm();
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "receipts",
  });

  console.log({ fv: form.watch() });

  const { data: dataClients } = useQuery({
    queryKey: "clients",
    queryFn: getClients(),
  });

  const { data: dataContainers } = useQuery({
    queryKey: "containers",
    queryFn: getContainers(),
  });

  return (
    <Edit saveButtonProps={form.saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <FormProvider {...form}>
          <ReiceptsForm />
        </FormProvider>
      </Box>
    </Edit>
  );
};
